/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getWorklists } from 'redux/reducers/worklists';
import { withRouter, Route } from 'react-router-dom';
import actions from 'redux/actions';

import type { ReactRouterProps, Translate, Fetchable, Worklist, ReduxState } from 'types';

import { parseInt, get } from 'lodash';
import protonesUtils from 'utils/protones';

// import CrudSidebar from 'components/CrudSidebar';
import Sidebar from 'components/Sidebar';
import ScrollableContent from 'components/ScrollableContent';
// import ToggleButton from 'components/ToggleButton';
import WorklistIntro from './WorklistIntro';
import WorklistEdit from './WorklistEdit';
import WorklistShow from './WorklistShow';
import styles from './styles.module.scss';

const mapStateToProps = (state: ReduxState, ownProps) => {
  const worklistId = ownProps.match.params.worklistId;
  const isNew = worklistId === 'create';
  return {
    isNew,
    worklistList: getWorklists(state),
    worklistId: !isNew ? parseInt(worklistId) : undefined,
    ...ownProps,
  };
};

type Props = ReactRouterProps & {
  worklistList: Fetchable<Worklist[]>,
  isNew: boolean,
  worklistId?: number,
  fetchWorklistList: typeof actions.fetchWorklistList,
  fetchWorklist: typeof actions.fetchWorklist,
  createWorklist: typeof actions.createWorklist,
  saveWorklist: typeof actions.saveWorklist,
  deleteWorklist: typeof actions.deleteWorklist,
  updateWl1: typeof actions.updateWl1,
  updateWl2: typeof actions.updateWl2,
  t: Translate,
};

class Worklists extends React.Component<Props, void> {
  componentDidMount() {
    const { isNew, worklistId, fetchWorklist, fetchWorklistList, worklistList } = this.props;
    if (!worklistList.data && !worklistList.fetching) {
      fetchWorklistList();
    }
    if (!isNew && worklistId) {
      fetchWorklist(worklistId);
    }
  }

  componentWillReceiveProps({ worklistId: newWorklistId }: Props) {
    const { worklistId, fetchWorklist, worklistList } = this.props;
    if (newWorklistId && newWorklistId !== worklistId && !worklistList.fetching) {
      fetchWorklist(newWorklistId);
    }
  }

  _handleRefreshWorklist = () => {
    const { worklistId, fetchWorklist, fetchWorklistList } = this.props;
    if (worklistId) {
      fetchWorklist(worklistId);
      protonesUtils.goTo(this.props, protonesUtils.routes.worklists.get(worklistId));
    } else {
      fetchWorklistList();
      protonesUtils.goTo(this.props, protonesUtils.routes.worklists.find());
    }
  };

  _handleCreateWorklist = () => {
    this.props.createWorklist();
    protonesUtils.goTo(this.props, protonesUtils.routes.worklists.create());
  };

  _handleSelectWorklist = (id: number) => {
    // this.props.fetchWorklist(id);
    protonesUtils.goTo(this.props, protonesUtils.routes.worklists.get(id));
  };

  _handleEditWorklist = (id: number) => {
    // this.props.fetchWorklist(id);
    protonesUtils.goTo(this.props, protonesUtils.routes.worklists.edit(id));
  };

  _handleDeleteWorklist = (id: number) => {
    //eslint-disable-next-line
    if (confirm(this.props.t('ARE_YOU_SURE'))) {
      this.props.deleteWorklist(id, () => {
        this.props.fetchWorklistList();
        protonesUtils.goTo(this.props, protonesUtils.routes.worklists.find());
      });
    }
  };

  render() {
    const {
      worklistId,
      isNew,
      t,
      // updateWl1,
      // updateWl2,
      worklistList,
    } = this.props;
    let sidebarTitle = t('WORKLISTS');
    if (worklistId) {
      const worklist = get(worklistList, 'data', []).find(worklist => worklist.id === worklistId);
      sidebarTitle = get(worklist, 'name', t('WORKLIST'));
    }
    return (
      <div className={styles.root}>
        <Sidebar
          title={sidebarTitle}
          onRefresh={this._handleRefreshWorklist}
          onAdd={worklistId ? undefined : this._handleCreateWorklist}
        />
        {/* <CrudSidebar
          title={sidebarTitle}
          activeItemId={worklistId}
          items={worklistList}
          buttons={item => [
            <ToggleButton
              key={'worklist_1'}
              icon={'worklist_1'}
              tooltip={item.isWorklist1 ? t('SELECTED_AS_WL1') : t('SELECT_AS_WL1')}
              // $FlowFixMe
              disabled={!item.isWorklist1}
              onClick={!item.isWorklist1 ? () => updateWl1(item.id) : undefined}
            />,
            <ToggleButton
              key={'worklist_2'}
              icon={'worklist_2'}
              tooltip={item.isWorklist2 ? t('SELECTED_AS_WL2') : t('SELECT_AS_WL2')}
              // $FlowFixMe
              disabled={!item.isWorklist2}
              onClick={!item.isWorklist2 ? () => updateWl2(item.id) : undefined}
            />,
          ]}
          onListRefresh={this._handleRefreshWorklist}
          onCreateItem={worklistId ? undefined : this._handleCreateWorklist}
          onSelectItem={({ id }) => this._handleSelectWorklist(id)}
          onEditItem={({ id }) => this._handleEditWorklist(id)}
          onDeleteItem={({ id }) => this._handleDeleteWorklist(id)}
        /> */}
        <ScrollableContent>
          <div className={styles.main}>
            {isNew ? (
              <WorklistEdit />
            ) : !worklistId ? (
              <WorklistIntro worklists={worklistList} />
            ) : (
              <div style={{ height: '100%' }}>
                <Route exact path={`${this.props.match.url}/`} component={WorklistShow} />
                <Route exact path={`${this.props.match.url}/edit`} component={WorklistEdit} />
              </div>
            )}
          </div>
        </ScrollableContent>
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(Worklists)
  )
);
